import styled from 'styled-components';
import Typography from '@mui/material/Typography';

import { center } from '../../core/styles';

export const ErrorWrapper = styled.div`
  ${center};
  flex-direction: column;
  height: 100%;
`;

export const ErrorMessage = styled(Typography)`
  margin-top: 27px;
  margin-bottom: 31px;
  text-align: center;
`;

export const ErrorLink = styled.a`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 1.7rem;
  line-height: 2rem;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
`;
